
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsQRPromptPayDialog extends Serenity.EntityDialog<PsQRPromptPayRow, any> {
        protected getFormKey() { return PsQRPromptPayForm.formKey; }
        protected getIdProperty() { return PsQRPromptPayRow.idProperty; }
        protected getLocalTextPrefix() { return PsQRPromptPayRow.localTextPrefix; }
        protected getNameProperty() { return PsQRPromptPayRow.nameProperty; }
        protected getService() { return PsQRPromptPayService.baseUrl; }
        protected getDeletePermission() { return PsQRPromptPayRow.deletePermission; }
        protected getInsertPermission() { return PsQRPromptPayRow.insertPermission; }
        protected getUpdatePermission() { return PsQRPromptPayRow.updatePermission; }

        protected form = new PsQRPromptPayForm(this.idPrefix);


        protected afterLoadEntity() {
            super.afterLoadEntity();

            
            
            var id = this.entity.Id
            if (id<9) {
                this.applyChangesButton.toggleClass('disabled', true);
                Serenity.EditorUtils.setReadOnly(this.form.paymentChannel, true);
            }

            

        }



    }
}